<template>
  <div>
    <headerSection mainMenu="cashback" />
    <main class="member-page cashback-page">
      <div class="member-page__content">
        <MemberPageHeading
          eyebrow="Daily reward"
          title="คืนยอดเล่น"
          subtitle="สรุปยอดวันนี้ พร้อมรับเครดิตกลับเข้ากระเป๋าหลัก"
        />

        <section class="member-card member-card--hero cashback-hero" aria-label="ยอดคืนที่พร้อมรับ">
          <div class="member-hero__top">
            <div>
              <div class="member-hero__label">ยอดคืนที่พร้อมรับ</div>
              <div class="member-hero__amount cashback-hero__amount">
                {{ numberWithCommas(cashback.total) }}
                <span class="member-hero__currency">บาท</span>
              </div>
              <div class="cashback-rate">คำนวณรอบล่าสุดของวันนี้</div>
            </div>
            <div class="member-hero__icon cashback-hero__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M4 8h16v11H4z" />
                <path d="M7 8V5h10v3M8 13h8m-4-3v6" />
              </svg>
            </div>
          </div>
        </section>

        <div class="member-section-head">
          <h2 class="member-section-head__title">สรุปยอดเล่นวันนี้</h2>
          <span class="member-section-head__meta">ข้อมูลรอบปัจจุบัน</span>
        </div>
        <div class="member-metric-grid">
          <article class="member-card member-metric">
            <span class="member-metric__label">ยอดฝาก</span>
            <strong class="member-metric__value">{{ numberWithCommas(cashback.deposit) }}</strong>
          </article>
          <article class="member-card member-metric">
            <span class="member-metric__label">ยอดถอน</span>
            <strong class="member-metric__value">{{ numberWithCommas(cashback.withdraw) }}</strong>
          </article>
          <article class="member-card member-metric member-metric--wide">
            <span class="member-metric__label">ยอดคืนทั้งหมด</span>
            <strong class="member-metric__value member-gold">
              {{ numberWithCommas(cashback.total) }}
              <span class="member-metric__micro">บาท</span>
            </strong>
          </article>
        </div>

        <div class="member-action-wrap">
          <MemberActionButton
            label="รับเงินคืนเข้ากระเป๋าหลัก"
            variant="gold"
            :disabled="!cashback.total || !cashback.key"
            @click="moveCashbackToWallet"
          />
        </div>
        <div class="member-note">
          <span class="member-note__icon">i</span>
          <span>รับยอดคืนได้เมื่อเครดิตในเกมต่ำกว่า 5 บาท ระบบจะตรวจสอบยอดก่อนทำรายการทุกครั้ง</span>
        </div>

        <div v-if="detail" class="member-section-head">
          <h2 class="member-section-head__title">รายละเอียดและเงื่อนไข</h2>
          <span class="member-section-head__meta">โปรดอ่านก่อนรับ</span>
        </div>
        <details v-if="detail" class="member-rule" open>
          <summary class="member-rule__summary">เงื่อนไขคืนยอดเล่น</summary>
          <div class="member-rule__content cashback-detail" v-html="nl2br(detail)" />
        </details>
      </div>
    </main>
    <footerSection />
  </div>
</template>

<script>
import firebase from '@/services/memberData'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
import axios from 'axios'
export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    MemberPageHeading: () => import('../components/member/MemberPageHeading.vue'),
    MemberActionButton: () => import('../components/member/MemberActionButton.vue')
  },
  data: function () {
    return {
      cashback: [],
      detail:'',
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    sites_credit(){
      return this.$store.state.user.sites_credit;
    },
  },
  methods: {
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    async moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key) {
        this.$store.commit('user/SET_LOADING', true)
        try {
          const sitesCredit = await this.$store.dispatch('user/moveCreditToWallet')
          const currentCredit = this.getCurrentCredit(sitesCredit)
          if (currentCredit > 5) {
            this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ' })
            this.$store.commit('user/SET_LOADING', false)
            return
          }
          await axios.get(`https://api.xxmac.win/qcashback/cashback/${this.cashback.key}`)
          setTimeout(() => {
            this.getCashBack()
            this.$store.commit('user/SET_LOADING', false)
          }, 2000)
        } catch (err) {
          console.error(err)
          this.$store.commit('user/SET_LOADING', false)
        }
        // axios.get(`https://api.xxmac.win/qcashback/cashback/${this.cashback.key}`)
        // setTimeout(() => {
        //   this.getCashBack()
        //   this.$store.commit('user/SET_LOADING', false)
        // }, 2000)
      }
    },
    getCurrentCredit (sitesCredit) {
      const credit = sitesCredit && typeof sitesCredit.credit !== 'undefined'
        ? sitesCredit.credit
        : (this.sites_credit && typeof this.sites_credit.credit !== 'undefined')
            ? this.sites_credit.credit
            : this.user.credit
      return Number(credit || 0)
    },
    checkStyle () {
      if (this.cashback && this.cashback.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref(`/cashback/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>
<style scoped>
.cashback-hero {
  --member-hero-halo: rgba(255, 202, 82, .15);
}

.cashback-hero__amount {
  color: #fff1c5;
}

.cashback-hero__icon {
  border-color: rgba(255, 202, 82, .24);
  color: #ffca52;
  background: rgba(255, 202, 82, .09);
}

.cashback-rate {
  display: inline-flex;
  margin-top: 13px;
  padding: 6px 9px;
  border-radius: 8px;
  color: #ffca52;
  background: rgba(255, 202, 82, .09);
  font-size: 9px;
}

.cashback-detail {
  white-space: normal;
}
</style>
